export default {
      id: "pause-2-usage",
      viewBox: "0 0 12 12",
      url: __webpack_public_path__ + "sprite-46b249.svg#pause-2-usage",
      toString: function () {
        return this.url;
      }
    }